export default __webpack_public_path__ + "static/media/welc4.d77721ad.gif";